
import { motion } from 'framer-motion';

const stats = [
  { icon: 'ri-heart-fill', number: '500+', label: 'Surprises Created' },
  { icon: 'ri-star-fill', number: '4.9★', label: 'Average Rating' },
  { icon: 'ri-emotion-happy-fill', number: '100%', label: 'Satisfaction Rate' }
];

const clients = [
  'https://public.readdy.ai/ai/img_res/519c3b985eae775e92fe0eeb405ccc8c.jpg',
  'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20happy%20smiling%20man%20with%20natural%20lighting%20clean%20background&width=100&height=100&seq=cli002&orientation=squarish',
  'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20happy%20smiling%20woman%20with%20natural%20lighting%20clean%20background&width=100&height=100&seq=cli003&orientation=squarish',
  'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20happy%20smiling%20man%20with%20natural%20lighting%20clean%20background&width=100&height=100&seq=cli004&orientation=squarish',
  'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20happy%20smiling%20woman%20with%20natural%20lighting%20clean%20background&width=100&height=100&seq=cli005&orientation=squarish'
];

export default function About() {
  return (
    <section className="py-20 bg-lavender relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <filter id="blob">
              <feGaussianBlur in="SourceGraphic" stdDeviation="10" />
            </filter>
          </defs>
          <circle cx="10%" cy="20%" r="150" fill="#E6E6FA" filter="url(#blob)" />
          <circle cx="90%" cy="80%" r="200" fill="#E6E6FA" filter="url(#blob)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="md:col-span-2"
          >
            <div className="text-purple text-sm font-medium mb-6">• About Us</div>
            <p className="text-purple/80 text-lg leading-relaxed font-light">
              At theintimateedit, we believe every moment deserves to be celebrated with beauty and intention. Our team of creative specialists transforms ordinary spaces into extraordinary experiences, crafting personalized surprise decorations that capture the essence of your most intimate celebrations.
            </p>
            <p className="text-purple/80 text-lg leading-relaxed font-light mt-6">
              From romantic proposals to milestone anniversaries, we handle every detail with care and creativity, ensuring your surprise is as unique as the person you're celebrating.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="md:col-span-3"
          >
            <div className="flex items-center gap-2 mb-6">
              {clients.map((client, idx) => (
                <div
                  key={idx}
                  className="w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow-lg"
                  style={{ marginLeft: idx > 0 ? '-12px' : '0', zIndex: clients.length - idx }}
                >
                  <img src={client} alt={`Happy client ${idx + 1}`} className="w-full h-full object-cover object-top" />
                </div>
              ))}
            </div>
            <div className="text-purple font-bold text-xl mb-8">
              Join 500+ Happy Clients
            </div>

            <div className="grid grid-cols-3 gap-4">
              {stats.map((stat, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.1 }}
                  whileHover={{ y: -5 }}
                  className="bg-white rounded-2xl p-6 shadow-lg text-center"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-coral to-pink rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className={`${stat.icon} text-white text-xl`}></i>
                  </div>
                  <div className="text-2xl font-bold text-charcoal mb-1">
                    {stat.number}
                  </div>
                  <div className="text-xs text-gray-600">
                    {stat.label}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
